import { useQueryClient } from 'react-query';
import produce from 'immer';

import { useGetContentQuery, GetContentQuery, GetContentQueryVariables } from 'api';
import { useCurrentUser, useQueryVariables } from 'hooks';

type QueryData = GetContentQuery;
type QueryVariables = GetContentQueryVariables;

const useAddComment = () => {
  const queryClient = useQueryClient();
  const queryVariables = useQueryVariables<QueryVariables>();
  const queryKey = useGetContentQuery.getKey(queryVariables);
  const currentUser = useCurrentUser();

  function addComment() {
    const baseState = queryClient.getQueryData<QueryData>(queryKey);

    const nextContentState =
      baseState &&
      produce(baseState, draftState => {
        draftState.getContent.comment_count++;
        draftState.getContent.commented_by.push({
          id: currentUser.id,
          full_name: currentUser.full_name,
          image: currentUser.image,
        });
      });

    if (baseState) {
      queryClient.setQueryData<QueryData>(queryKey, nextContentState);
    }

    return baseState;
  }

  return addComment;
};

export default useAddComment;
